import React, { useState } from "react";
import signupimage from "../../images/signup-g.svg";
import { Link } from "react-router-dom";
import axios from "axios";
import ScrollToTop from "../ScrollToTop";

const MyAccountSignUp = () => {
  const [user, setUser] = useState({
    username: "",
    role: "",
  });
  const [acceptedPolicy, setAcceptedPolicy] = useState(false);
  const policyPageUrl = "/policies-legal";

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const generatePassword = (username) => {
    return username + Math.floor(1000 + Math.random() * 9000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!acceptedPolicy) {
      alert("Please accept the Privacy Policy before registration.");
      return;
    }
    const passwordGenerated = generatePassword(user.username);
    const userData = { ...user, password: passwordGenerated };

    try {
      await axios.post("https://sakhisshop.com/api/users/register", userData);
      alert(
        `User registered successfully!\nYour password: ${passwordGenerated}`,
      );
    } catch (error) {
      console.error("Registration failed", error);
      alert("Registration failed!");
    }
  };

  return (
    <div>
      <ScrollToTop />
      <section className="my-lg-14 my-8 ">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-6 col-lg-4 order-lg-1 order-2">
              <img src={signupimage} alt="freshcart" className="img-fluid" />
            </div>
            <div className="col-12 col-md-6 offset-lg-1 col-lg-4 order-lg-2 order-1">
              <div className="mb-lg-9 mb-5">
                <h1 className="mb-1 h2 fw-bold">Register Your User</h1>
                <p>
                  Welcome to FreshCart! Please enter your details to continue.
                </p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-12">
                    <input
                      type="text"
                      name="username"
                      className="form-control"
                      placeholder="Username"
                      value={user.username}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <select
                      name="role"
                      className="form-select"
                      value={user.role}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Role</option>
                      <option value="Kosoft">Kosoft</option>
                      <option value="Shopkeeper">Shopkeeper</option>
                      <option value="Sanjay">Sanjay</option>
                      <option value="Customer">Customer</option>
                    </select>
                  </div>
                  <div className="col-12 d-grid">
                    <button type="submit" className="btn btn-primary">
                      Register
                    </button>
                    <span className="navbar-text mt-2">
                      Already have an account?{" "}
                      <Link to="/MyAccountsSignIn">Sign in</Link>
                    </span>
                  </div>
                  <div className="col-12">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="privacyAcceptance"
                        checked={acceptedPolicy}
                        onChange={(e) => setAcceptedPolicy(e.target.checked)}
                        required
                      />
                      <label
                        className="form-check-label"
                        htmlFor="privacyAcceptance"
                      >
                        I have read and accept the{" "}
                        <a href={policyPageUrl}>Privacy Policy</a>,{" "}
                        <a href={policyPageUrl}>Refund Policy</a> and{" "}
                        <a href={policyPageUrl}>App Usage MOU</a>.
                      </label>
                    </div>
                  </div>
                  <p>
                    <small>
                      By continuing, you agree to our{" "}
                      <a href={policyPageUrl}>Privacy Policy</a>.
                    </small>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyAccountSignUp;
